// Site guard (design/DOMAIN_SPLIT.md, "Route ownership"): on the Aqueduct
// build, nothing in this group is prerendered, so no Iliad HTML exists in that
// deploy's output. Runtime requests are rejected by +layout.server.ts.
import { IS_AQUEDUCT } from '$lib/site';

export const prerender = !IS_AQUEDUCT;
